// 导入组件
import Vue from 'vue';

import Router from 'vue-router';


export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: () => import('@/views/index'),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/login',
      name: '登录',
      component: () => import('@/views/login'),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/home',
      name: '首页',
      component: () => import('@/views/home/home'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/audit',
      name: '首页',
      component: () => import('@/views/index'),
      iconCls: 'el-icon-tickets',
      children: [
        {
          path: '/audit/home',
          name: '首页',
          component: () => import('@/views/home/home'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/map',
          name: '地图',
          component: () => import('@/views/map/index'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/maps',
          name: '地图',
          component: () => import('@/views/map/map'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/collection',
          name: '楼宇采集审核',
          component: () => import('@/views/audit/collection/collection'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/danger',
          name: '隐患管理',
          component: () => import('@/views/audit/danger/danger'),
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/audit/intact',
          name: '基本完好管理',
          component: () => import('@/views/audit/intact/intact'),
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/audit/review',
          name: '复核管理',
          component: () => import('@/views/audit/review/review'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/review_overseer',
          name: '吴强隐患复查审核',
          component: () => import('@/views/audit/review_overseer/review_overseer'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/census',
          name: '普查管理',
          component: () => import('@/views/audit/census/census'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/statistics',
          name: '统计管理',
          component: () => import('@/views/audit/statistics/statistics'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/errStatistics',
          name: '错误统计',
          component: () => import('@/views/audit/errorStatistics/errorStatistics'),
          meta: {
            requireAuth: true
          }
        },
        // {
        //   path: '/audit/statement',
        //   name: '隐患统计',
        //   component: () => import('@/views/audit/statement/statement'),
        //   meta: {
        //     requireAuth: true
        //   }
        // },
        {
          path: '/audit/information',
          name: '数据展示',
          component: () => import('@/views/audit/information/information'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/building_list',
          name: '一楼一表列表',
          component: () => import('@/views/audit/building_list/building_list'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/building_form',
          name: '一楼一表',
          component: () => import('@/views/audit/building_form/building_form'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/building_map',
          name: '一楼一表地图',
          component: () => import('@/views/audit/building_map/building_map'),
          meta: {
            requireAuth: true
          }
        },

        {
          path: '/audit/log',
          name: 'lv3，lv4，lv5用户日志',
          component: () => import('@/views/audit/log/log'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/review_log',
          name: 'lv3，lv4，lv5用户复核日志',
          component: () => import('@/views/audit/review_log/review_log'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/review_record',
          name: '复核记录',
          component: () => import('@/views/audit/review_record/review_record'),
        },
        {
          path: '/audit/building_log',
          name: '一楼一表日志',
          component: () => import('@/views/audit/building_log/building_log'),
        },
        {
          path: '/audit/city_illegal',
          name: '城市违建管理',
          component: () => import('@/views/audit/city_illegal/city_illegal'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/city_environment',
          name: '市容环境督查管理',
          component: () => import('@/views/audit/city_environment/city_environment'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/audit/city_environment_review',
          name: '市容环境督查复查管理',
          component: () => import('@/views/audit/city_environment_review/review'),
          meta: {
            requireAuth: true
          }
        }
      ]

    },
    {
      path: '/system',
      name: '用户',
      component: () => import('@/views/index'),
      iconCls: 'el-icon-tickets',
      children: [
        {
          path: '/system/userList/log',
          name: '用户日志',
          component: () => import('@/views/system/log/log'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/system/disposition',
          name: '配置管理',
          component: () => import('@/views/system/disposition/disposition'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/system/formLog',
          name: '表单日志',
          component: () => import('@/views/system/formLog/formLog'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/system/userList',
          name: '用户管理',
          component: () => import('@/views/user/userList/userList'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/system/location',
          name: '位置管理',
          component: () => import('@/views/user/location/location'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/system/export',
          name: '导出队列',
          component: () => import('@/views/system/export/export'),
        }
      ]
    },

    {
      path: '/statement',
      name: '统计管理',
      component: () => import('@/views/index'),
      iconCls: 'el-icon-tickets',
      children: [
        {
          path: '/statement/dangerStatement',
          name: '隐患统计',
          component: () => import('@/views/statement/dangerStatement/dangerStatement'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/statement/dangerReviewStatement',
          name: '隐患复查统计',
          component: () => import('@/views/statement/dangerReviewStatement/dangerReviewStatement'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/statement/buildingStatement',
          name: '一楼一表统计',
          component: () => import('@/views/statement/buildingStatement/buildingStatement'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/statement/illegalStatement',
          name: '城市违建统计',
          component: () => import('@/views/statement/illegalStatement/illegalStatement'),
          meta: {
            requireAuth: true
          }
        }
      ],
    }
  ]
})
Vue.use(Router);



// WEBPACK FOOTER //
// ./src/router/index.js